import { createBrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import Layout from "../Layout/Layout";
import JobTitleMaster from "../Pages/JobTitleMaster/JobTitleMaster";
import FilePreviewPage from "../Components/FilePreviewPage";
import PayrollPreference from "../Pages/PayrollPreference/PayrollPreference";
import Customize from "../Pages/TimeAndAttendanceReport/Customize/Customize";
import LabourReportsPage from "../Pages/TimeAndAttendanceReport/LabourReport/TimeAndAttendance";
import timeAndAttendanceTheme from "../Theme/timeAndAttendanceTheme";

const router = createBrowserRouter([
    {
        path: "/:Payroll/:clintUrl/:authId/:menuId/:corpId",
        element: <Layout />,
    },
    {
        path: "/job-master/:clintUrl/:authId/:menuId/:corpId",
        element: <JobTitleMaster />,
    },
    {
        path: "/Payroll-Preference/:authId/:menuId/:corpId",
        element: <PayrollPreference />,
    },
    {
        path: "/PayEmp-Mapping/:clintUrl/:authId/:menuId/:payrollEmpId/:popupID",
        element: <Layout />,
    },
    {
        path: "/:payroll/filepreview/:clintUrl/:authId/:ReferenceID/:popupID",
        element: <FilePreviewPage />
    },
    {
        path: "/TimeandAttendance-report/:clintUrl/:authId/:menuId/:corpId",
        element: (
            <ThemeProvider theme={timeAndAttendanceTheme}>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    autoHideDuration={3000}
                >
                    <LabourReportsPage />
                </SnackbarProvider>
            </ThemeProvider>
        ),
    },
    {
        path: "/TimeandAttendance/:clintUrl/:authId/:menuId/:corpId",
        element: (
            <ThemeProvider theme={timeAndAttendanceTheme}>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    autoHideDuration={3000}
                >
                    <Customize />
                </SnackbarProvider>
            </ThemeProvider>
        ),
    },
]);

export default router;
